.root {
  display: inline-flex;
}

.clickable {
  cursor: pointer;
}

.name {
  margin-left: 8px;
  margin-top: 8px;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: var(--tuna-typography-caption-fontSize);
}
